module.exports = __webpack_public_path__ + "img/hd2.1b4fbd96.png";